import usePermittedQuery from '_api/queries/usePermittedQuery';
import { User } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_USER_KEY = 'get-user-by-id';

export const useGetUserById = (id: number) => {
  return usePermittedQuery<User>(
    [ACCOUNT_TYPE.ADMIN, ACCOUNT_TYPE.ORG_ADMIN, ACCOUNT_TYPE.HOS_ADMIN],
    () => `/user/${id}`,
    {},
    [GET_USER_KEY, id],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
